import React, { useEffect } from "react";
import { YOUTUBE_VIDEO_API, YOUTUBE_VIDEO_API_ADD } from "../utils/contants";
import VideoCard from "./VideoCard";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addVideo } from "../utils/videoSlice";
import Shimmer from "./Shimmer";
import { filterVideo } from "../utils/filterSlice";

const VideoContainer = () => {
  const isMenuOpen = useSelector((store) => store.app.isMenuOpen);
  const videos = useSelector((store) => store.video.videos);
  const dispatch = useDispatch();

  useEffect(() => {
    window.addEventListener("scroll", handelInfiniteScroll);
    return () => window.removeEventListener("scroll", handelInfiniteScroll);
  }, []);
  useEffect(() => {
    getData();
  }, []);

  console.log(videos);

  const handelInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        let newData = await fetch(YOUTUBE_VIDEO_API_ADD);

        let res = await newData.json();

        dispatch(addVideo(res?.items));
        dispatch(filterVideo(res?.items));
      }
    } catch (error) {
      throw Error(error);
    }
  };

  const getData = async () => {
    const data = await fetch(YOUTUBE_VIDEO_API);
    const json = await data.json();

    dispatch(addVideo(json?.items));
    dispatch(filterVideo(json?.items));
  };
  if (videos.length === 0) {
    return <Shimmer />;
  }
  return isMenuOpen ? (
    <div className="flex flex-wrap mt-16 ml-[162px] ">
      {videos.map((video, index) => (
        <Link
          to={"/watch?v=" + video.id}
          key={video.id + index}
          state={{
            title: video.snippet.title,
            channelTitle: video.snippet.channelTitle,
            description: video.snippet.description,
          }}
        >
          <VideoCard info={video} />
        </Link>
      ))}
    </div>
  ) : (
    <div className={"flex flex-wrap mt-16 ml-20"}>
      {videos.map((video, index) => (
        <Link
          to={"/watch?v=" + video.id}
          key={video.id + index}
          state={{
            title: video.snippet.title,
            channelTitle: video.snippet.channelTitle,
            description: video.snippet.description,
          }}
        >
          <VideoCard info={video} />
        </Link>
      ))}
    </div>
  );
};

export default VideoContainer;
